import React, { Fragment } from "react";
import { Col, Label, FormGroup } from "reactstrap";

import moment from "moment";
import DatePicker from "react-datepicker";

const dateToday = new Date();
var dateYesterday = new Date();
const dateOffset = 24 * 60 * 60 * 1000; // 1 day
dateYesterday.setTime(dateYesterday.getTime() - dateOffset);

export default class searchDate extends React.Component {
  constructor(props) {
    super();
    this.state = {
      startDate: moment(dateYesterday.getTime()),
      endDate: moment(dateToday.getTime()),
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChangeData = ({ startDate, endDate }) => {
    const { nameStart, nameEnd } = this.props;

    startDate = startDate || this.state.startDate;
    endDate = endDate || this.state.endDate;

    if (startDate.isAfter(endDate)) {
      endDate = startDate;
    }

    this.setState({ startDate, endDate }, () => {
      if (nameStart && nameEnd) {
        this.props.handleChangeData({ startDate, endDate, nameStart, nameEnd });
      } else {
        this.props.handleChangeData({ startDate, endDate });
      }
    });
  };

  handleChangeStart = (startDate) => this.handleChangeData({ startDate });

  handleChangeEnd = (endDate) => this.handleChangeData({ endDate });

  /*********************************** RENDER ***********************************/
  render() {
    return (
      <Fragment>
        <Col xl={6} md={6} sm={12} style={{ display: "inline-block" }}>
          <FormGroup>
            <Label for="exampleEmail" className="mr-sm-2">
              Started between
            </Label>
            <DatePicker
              selected={this.state.startDate}
              selectsStart
              className="form-control"
              dateFormat="DD/MM/YYYY"
              dateFormatCalendar="DD/MM/YYYY"
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onChange={this.handleChangeStart}
            />
          </FormGroup>
        </Col>
        <Col xl={6} md={6} sm={12} style={{ display: "inline-block" }}>
          <FormGroup>
            <Label for="examplePassword" className="mr-sm-2">
              and
            </Label>
            <DatePicker
              selected={this.state.endDate}
              selectsEnd
              className="form-control"
              dateFormat="DD/MM/YYYY"
              dateFormatCalendar="DD/MM/YYYY"
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onChange={this.handleChangeEnd}
            />
          </FormGroup>
        </Col>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Search/SearchDate.js